<template>
    <span v-if="istext" class="enquiry-action-trigger">Status Update</span>
    <el-tag v-else class="mr-2 bdark" effect="dark" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click.stop="open()">
        Status Update
    </el-tag>
    <el-drawer v-model="drawer" direction="rtl" :before-close="handleClose" :before-open="handleOpen">
        <template #header>

            <h4 >Enquiry Action</h4>
        </template>
        <template #default>
            <el-form
                label-position="top"
                ref="ruleFormRef"
                :model="form"
                status-icon
                :rules="rules"

            >

                <el-radio-group  v-if="currentaction==null" class="enquiryactiongroup" v-model="currentaction"  size="large"  >
                    <el-radio-button v-if="user.department=='QC'" label="qc" >
                        <template #default>
                            <div class="action-option">
                                <div class="action-option-main">
                                    <img style="height: 45px;" src="/images/willfinalize.png"/>
                                    <span>Verify QC</span>
                                </div>
                                <div class="action-option-hint">→ {{ hintFor('qc') }}</div>
                            </div>
                        </template>
                    </el-radio-button>
                    <el-radio-button label="notreachable"  >
                        <template #default>
                            <div class="action-option">
                                <div class="action-option-main">
                                    <img style="height: 45px;" src="/images/notreachable.png"/>
                                    <span>Traveler not reachable</span>
                                </div>
                                <div class="action-option-hint">→ {{ hintFor('notreachable') }}</div>
                            </div>
                        </template>
                    </el-radio-button>
                    <el-radio-button label="wontbook" >
                        <template #default>
                            <div class="action-option">
                                <div class="action-option-main">
                                    <img style="height: 45px;" src="/images/wontbook.png"/>
                                    <span>Won't book with me</span>
                                </div>
                                <div class="action-option-hint">→ {{ hintFor('wontbook') }}</div>
                            </div>
                        </template>
                    </el-radio-button>
                    <el-radio-button label="talkinprogress" v-if="user.department!='QC'" >
                        <template #default>
                            <div class="action-option">
                                <div class="action-option-main">
                                    <img style="height: 45px;" src="/images/talkinprogress.png"/>
                                    <span>Talk in progress with traveler</span>
                                </div>
                                <div class="action-option-hint">→ {{ hintFor('talkinprogress') }}</div>
                            </div>
                        </template>
                    </el-radio-button>
                    <el-radio-button label="willfinalize" v-if="user.department!='QC'">
                        <template #default>
                            <div class="action-option">
                                <div class="action-option-main">
                                    <img style="height: 45px;" src="/images/willfinalize.png"/>
                                    <span>Traveler will finalize and is My Hot</span>
                                </div>
                                <div class="action-option-hint">→ {{ hintFor('willfinalize') }}</div>
                            </div>
                        </template>
                    </el-radio-button>
                    <el-radio-button label="followup" >
                        <template #default>
                            <div class="action-option">
                                <div class="action-option-main">
                                    <img style="height: 45px;" src="/images/callback.png"/>
                                    <span>Follow-up</span>
                                </div>
                                <div class="action-option-hint">→ {{ hintFor('followup') }}</div>
                            </div>
                        </template>
                    </el-radio-button>
                    <el-radio-button label="quotationrequested" >
                        <template #default>
                            <div class="action-option">
                                <div class="action-option-main">
                                    <img style="height: 45px;" src="/images/willfinalize.png"/>
                                    <span>Quotation Requested</span>
                                </div>
                                <div class="action-option-hint">→ {{ hintFor('quotationrequested') }}</div>
                            </div>
                        </template>
                    </el-radio-button>
                    <el-radio-button label="callback" >
                        <template #default>
                            <div class="action-option">
                                <div class="action-option-main">
                                    <img style="height: 45px;" src="/images/callback.png"/>
                                    <span>Requested For Callback</span>
                                </div>
                                <div class="action-option-hint">→ {{ hintFor('callback') }}</div>
                            </div>
                        </template>
                    </el-radio-button>
                    <el-radio-button label="selfcallback" >
                        <template #default>
                            <div class="action-option">
                                <div class="action-option-main">
                                    <img style="height: 45px;" src="/images/callback.png"/>
                                    <span>Customer Self Callback</span>
                                </div>
                                <div class="action-option-hint">→ {{ hintFor('selfcallback') }}</div>
                            </div>
                        </template>
                    </el-radio-button>
                    <el-radio-button label="planlater" >
                        <template #default>
                            <div class="action-option">
                                <div class="action-option-main">
                                    <img style="height: 45px;" src="/images/callback.png"/>
                                    <span>Plan Later</span>
                                </div>
                                <div class="action-option-hint">→ {{ hintFor('planlater') }}</div>
                            </div>
                        </template>
                    </el-radio-button>
                </el-radio-group>

                <div class="enquiryaction" v-else>
                    <el-row>

                        <el-col :span="24">
                            <el-form-item label="Status"  prop="status">
                                <el-radio-group v-model="form.status" @change="actionstatuschanged()">
                                    <el-radio v-for="action in currentnoteactions" :label="action" border>{{action}}</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row v-if="showNotReachableReminder">
                        <el-col :span="24">
                            <el-form-item label="Reminder When" prop="reminder_preset">
                                <el-radio-group v-model="form.reminder_preset" @change="reminderPresetChanged()">
                                    <el-radio v-for="option in reminderPresets" :key="option" :label="option" border>{{ option }}</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row v-if="currentaction=='qc'">
                        <el-col :span="24">
                            <el-form-item label="Team"  prop="dest_team">
                                <el-radio-group v-model="form.dest_team" >
                                    <el-radio  label="International" border>International</el-radio>
                                    <el-radio  label="Domestic" border>Domestic</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="Language"  prop="language">
                                <el-select v-model="form.language" class="m-2" placeholder="Select" size="large">
                                    <el-option
                                        v-for="item in languages"
                                        :key="item"
                                        :label="item"
                                        :value="item"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row v-if="showReminderField">
                        <el-col :span="24">
                            <el-form-item label="Set Reminder"  prop="reminder">
                                <el-input
                                    v-model="form.reminder"
                                    type="datetime-local"
                                />
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row v-if="showNoteField">
                        <el-col :span="24">
                            <el-form-item label="Add note" prop="note">
                                <el-input
                                    v-model="form.note"
                                    :rows="3"
                                    type="textarea"
                                    placeholder="Enter Note here"
                                />
                            </el-form-item>
                        </el-col>
                    </el-row>





                </div>
            </el-form>

        </template>
        <template #footer >
            <div style="flex: auto" v-if="currentaction!=null">

                <el-button  type="primary" @click="submitForm()" :loading="loading" :disabled="loading">Status Update</el-button>




            </div>
        </template>
    </el-drawer>
</template>

<script>
import {
    ElRadio,
    ElRadioGroup,
    ElRadioButton,
    ElInput,
    ElSelect,
    ElOption,
    ElFormItem,
    ElForm,
    ElCol,
    ElRow,
    ElButton,
    ElCard,
    ElDivider,
    ElDrawer,
    ElDatePicker, ElTag, ElAvatar, ElSkeleton,ElUpload,ElMessage
} from 'element-plus'
import 'element-plus/dist/index.css'
import $ from "jquery";
import moment from "moment";
export default {
    name: "EnquiryAction",
    components: { ElRadioGroup,
        ElRadio,ElRadioButton,ElInput,ElUpload,ElSelect,ElOption,ElDatePicker,ElFormItem,ElForm,ElCol,ElRow,ElButton,ElCard,ElTag,ElAvatar,ElDivider,ElDrawer,ElSkeleton },
    props:{
        enquiry: {
            type: Object,
            default () {
                return null
            }
        },
        user: {
            type: Object,
            default () {
                return null
            }
        },
        languages: {
            type: Object,
            default () {
                return null
            }
        },
        istext: {
            type: Boolean,
            default () {
                return false
            }
        },
    },
    data() {
        return {
            drawer: false,
            loading: false,
            currentaction:null,
            currentnoteactions:[],
            rules:{
                status: [{ required: true, trigger: 'change', message:'Required' }],
                dest_team: [{ required: true, trigger: 'change', message:'Required' }],
                language: [{ required: true, trigger: 'change', message:'Required' }],
                reminder_preset: [
                    {
                        validator: (rule, value, callback) => {
                            if (this.showNotReachableReminder && (!value || !String(value).trim())) {
                                callback(new Error('Required'));
                            } else {
                                callback();
                            }
                        },
                        trigger: ['change'],
                    }
                ],
                reminder: [
                    {
                        validator: (rule, value, callback) => {
                            if (this.showReminderField && (!value || !String(value).trim())) {
                                callback(new Error('Required'));
                            } else {
                                callback();
                            }
                        },
                        trigger: ['change', 'blur'],
                    }
                ],
                note: [
                    {
                        validator: (rule, value, callback) => {
                            if (this.form.status === 'Other' && (!value || !String(value).trim())) {
                                callback(new Error('Enter Note'));
                            } else {
                                callback();
                            }
                        },
                        trigger: ['blur', 'change'],
                    }
                ],
            },
            reminderPresets:["After 2 Hour","In Afternoon","In Evening","Tomorrow Morning","Tomorrow Afternoon","Tomorrow Evening","Other"],
            noteactions:{
                qc:["Customer is Intrested","Other"],
                notreachable:["Call not Picked","Phone number doesn't work","Couldn't talk to traveler this time, try again later","Tried enough, leave the lead","Other"],
                wontbook:["Dupe Enquiry","Traveler is not sure about the plan/cancelled plan","Traveler booked with someone else","Low Budget","Not Intrested","Regarding Job","Didnt Enquiry","Fake Enquiry","Just Enquiry","Test Enquiry","Other"],
                talkinprogress:["Had Initial Talk","Quotation Sent","Initial stage only - Quote not seen","Getting Quote/package customized","Traveler interested, but will book after few weeks","Other"],
                willfinalize:["Negotiating / Will finalize in 2 to 3 days","Invoice sent to traveler","Traveler will pay soon on my invoice","Other"],
                callback:["After 2 Hour","In Afternoon","In Evening","Tomorrow Morning","Tomorrow Afternoon","Tomorrow Evening","Other"],
                followup:["After 2 Hour","In Afternoon","In Evening","Tomorrow Morning","Tomorrow Afternoon","Tomorrow Evening","Other"],
                quotationrequested:["After 2 Hour","In Afternoon","In Evening","Tomorrow Morning","Tomorrow Afternoon","Tomorrow Evening","Other"],
                selfback:["After 2 Hour","In Afternoon","In Evening","Tomorrow Morning","Tomorrow Afternoon","Tomorrow Evening","Other"],
                planlater:["After 1 Month","After 2 Months","After 3 Months","After 4 Months","After 5 Months","After 6 Months","After 1 Year","Other"],

            },
            form:{
                type:'',
                status:'',
                note:'',
                reminder:'',
                reminder_preset:'',
                dest_team:'',
                language:''
            },

        }
    },
    emits: ["actionevent"],
    watch: {
        currentaction: function () {
            this.aactionchanged()
        }
    },
    computed: {
        isQcUser() {
            return this.user && this.user.department === 'QC';
        },
        actionStatusHints() {
            if (this.isQcUser) {
                return [
                    { key: 'qc', label: 'Verify QC', result: 'Pending (QC Verified)' },
                    { key: 'notreachable', label: 'Traveler not reachable', result: 'Pending (or Closed if “Tried enough, leave the lead”)' },
                    { key: 'wontbook', label: "Won't book with me", result: 'Closed' },
                    { key: 'followup', label: 'Follow-up', result: 'Keeps current status + sets follow-up' },
                    { key: 'quotationrequested', label: 'Quotation Requested', result: 'Keeps current status + sets follow-up' },
                    { key: 'callback', label: 'Requested For Callback', result: 'Keeps current status + sets follow-up' },
                    { key: 'selfcallback', label: 'Customer Self Callback', result: 'Keeps current status' },
                    { key: 'planlater', label: 'Plan Later', result: 'Closed + sets follow-up' },
                ];
            }

            return [
                { key: 'notreachable', label: 'Traveler not reachable', result: 'InProgress + set follow-up (or Closed if “Tried enough, leave the lead”)' },
                { key: 'wontbook', label: "Won't book with me", result: 'Closed' },
                { key: 'talkinprogress', label: 'Talk in progress', result: 'InProgress' },
                { key: 'willfinalize', label: 'Traveler will finalize (Hot)', result: 'InProgress + Hot Lead' },
                { key: 'followup', label: 'Follow-up', result: 'InProgress + sets follow-up' },
                { key: 'quotationrequested', label: 'Quotation Requested', result: 'InProgress + sets follow-up' },
                { key: 'callback', label: 'Requested For Callback', result: 'InProgress + sets follow-up' },
                { key: 'selfcallback', label: 'Customer Self Callback', result: 'InProgress + sets follow-up' },
                { key: 'planlater', label: 'Plan Later', result: 'Closed + sets follow-up' },
            ];
        },
        showNoteField() {
            return this.form.status === 'Other';
        },
        notReachableReminderStatuses() {
            return [
                'Call not Picked',
                "Phone number doesn't work",
                "Couldn't talk to traveler this time, try again later",
            ];
        },
        showNotReachableReminder() {
            return this.currentaction === 'notreachable'
                && this.notReachableReminderStatuses.includes(this.form.status);
        },
        showReminderField() {
            return this.currentaction === 'callback'
                || this.currentaction === 'selfcallback'
                || this.currentaction === 'planlater'
                || this.currentaction === 'followup'
                || this.currentaction === 'quotationrequested'
                || this.showNotReachableReminder;
        }
    },
    methods: {
        open() {
            this.drawer = true;
        },
        hintFor(key) {
            const hint = this.actionStatusHints.find((item) => item.key === key);
            return hint ? hint.result : '';
        },
        aactionchanged(){

          if(this.currentaction=="qc"){
              this.currentnoteactions=this.noteactions.qc;
          }
          else if(this.currentaction=="notreachable"){
                this.currentnoteactions=this.noteactions.notreachable;
            }
          else if(this.currentaction=="wontbook"){
              this.currentnoteactions=this.noteactions.wontbook;
          }
          else if(this.currentaction=="talkinprogress"){
              this.currentnoteactions=this.noteactions.talkinprogress;
          }
          else if(this.currentaction=="willfinalize"){
              this.currentnoteactions=this.noteactions.willfinalize;
          }
          else if(this.currentaction=="followup"){
              this.currentnoteactions=this.noteactions.followup;
          }
          else if(this.currentaction=="quotationrequested"){
              this.currentnoteactions=this.noteactions.quotationrequested;
          }
          else if(this.currentaction=="callback"){
              this.currentnoteactions=this.noteactions.callback;
          }
          else if(this.currentaction=="selfcallback"){
              this.currentnoteactions=this.noteactions.selfback;
          }
          else if(this.currentaction=="planlater"){
              this.currentnoteactions=this.noteactions.planlater;
          }


          this.form.type=this.currentaction;
          this.form.status='';
          this.form.note='';
          this.form.reminder='';
          this.form.reminder_preset='';


        },
        applyReminderFromPreset(preset) {
            if (preset === 'After 2 Hour') {
                this.form.reminder = moment().add(2, 'hours').format('YYYY-MM-DDTHH:mm');
            } else if (preset === 'In Afternoon') {
                this.form.reminder = moment().format('YYYY-MM-DD') + 'T14:00';
            } else if (preset === 'In Evening') {
                this.form.reminder = moment().format('YYYY-MM-DD') + 'T18:00';
            } else if (preset === 'Tomorrow Morning') {
                this.form.reminder = moment().add(1, 'day').format('YYYY-MM-DD') + 'T10:00';
            } else if (preset === 'Tomorrow Afternoon') {
                this.form.reminder = moment().add(1, 'day').format('YYYY-MM-DD') + 'T13:00';
            } else if (preset === 'Tomorrow Evening') {
                this.form.reminder = moment().add(1, 'day').format('YYYY-MM-DD') + 'T18:00';
            } else if (preset === 'After 1 Month') {
                this.form.reminder = moment().add(1, 'month').format('YYYY-MM-DD') + 'T10:00';
            } else if (preset === 'After 2 Months') {
                this.form.reminder = moment().add(2, 'month').format('YYYY-MM-DD') + 'T10:00';
            } else if (preset === 'After 3 Months') {
                this.form.reminder = moment().add(3, 'month').format('YYYY-MM-DD') + 'T10:00';
            } else if (preset === 'After 4 Months') {
                this.form.reminder = moment().add(4, 'month').format('YYYY-MM-DD') + 'T10:00';
            } else if (preset === 'After 5 Months') {
                this.form.reminder = moment().add(5, 'month').format('YYYY-MM-DD') + 'T10:00';
            } else if (preset === 'After 6 Months') {
                this.form.reminder = moment().add(6, 'month').format('YYYY-MM-DD') + 'T10:00';
            } else if (preset === 'After 1 Year') {
                this.form.reminder = moment().add(1, 'year').format('YYYY-MM-DD') + 'T10:00';
            } else {
                this.form.reminder = '';
            }
        },
        reminderPresetChanged() {
            this.applyReminderFromPreset(this.form.reminder_preset);
        },
        actionstatuschanged(){
            if (this.form.status !== 'Other') {
                this.form.note = '';
            }

            if (this.currentaction === 'notreachable') {
                if (!this.showNotReachableReminder) {
                    this.form.reminder = '';
                    this.form.reminder_preset = '';
                }
                return;
            }

            if(this.form.type=='callback' || this.form.type=='selfcallback' || this.form.type=='planlater' || this.form.type=='followup' || this.form.type=='quotationrequested'){
                this.applyReminderFromPreset(this.form.status);
            }

        },
        handleClose() {
            this.drawer = false
            this.currentaction=null
            this.form.type=''
            this.form.status=''
            this.form.note=''
            this.form.reminder=''
            this.form.reminder_preset=''
            this.form.dest_team=''
            this.form.language=''

        },
        handleOpen(){
             this.currentaction=null
         },
        submitForm(){
            var formEl=this.$refs.ruleFormRef;
            let currentObj = this;
            if (!formEl) return
            formEl.validate((valid) => {
                if (valid) {
                    currentObj.loading=true;
                    axios.post('/enquiry/addenquirynote?id='+this.enquiry.id,currentObj.form).then(function (response) {

                        currentObj.drawer = false
                        currentObj.currentaction=null
                        currentObj.form.type=''
                        currentObj.form.status=''
                        currentObj.form.note=''
                        currentObj.form.reminder=''
                        currentObj.form.reminder_preset=''
                        currentObj.form.dest_team=''
                        currentObj.form.language=''
                        toastr.success('Note Added Succesfully.');
                        currentObj.$emit('actionevent');
                        currentObj.loading=false;
                    })
                        .catch(function (error) {
                            toastr.error('Something Wrong try again.');
                            currentObj.loading=false;
                        });

                } else {

                    return false
                }
            })
        },
    }

}
</script>

<style scoped>
.enquiry-action-trigger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: inherit;
    font-weight: inherit;
}
.action-option {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    width: 100%;
    white-space: normal;
    line-height: 1.35;
}
.action-option-main {
    display: flex;
    align-items: center;
    gap: 8px;
}
.action-option-main span {
    font-weight: 600;
}
.action-option-hint {
    margin-left: 53px;
    font-size: 11px;
    font-weight: 400;
    color: #909399;
    white-space: normal;
}
:deep(.enquiryactiongroup .el-radio-button__inner) {
    height: auto !important;
    min-height: 56px;
    padding-top: 10px;
    padding-bottom: 10px;
    white-space: normal;
}
</style>
